import React, { Component } from 'react';

import { withCookies } from '../../hocs';
import { CookieName } from '../../enums';

import CookiePolicyBanner from './component';

class CookiePolicyBannerContainer extends Component {
  handleAccept = () => {
    const {
      injected: {
        cookies: { setCookie },
      },
    } = this.props;

    setCookie(CookieName.ACCEPTED_COOKIE_POLICY, true, {
      expires: new Date(2030, 0, 1), // Jan 1st, 2030
      path: '/',
    });
  };

  render() {
    const {
      injected: {
        cookies: { getCookie },
      },
    } = this.props;

    if (getCookie(CookieName.ACCEPTED_COOKIE_POLICY)) return null;

    return <CookiePolicyBanner onAccept={this.handleAccept} />;
  }
}

CookiePolicyBannerContainer.defaultProps = {
  injected: {
    cookies: {
      getCookie: () => {},
      setCookie: () => {},
    },
  },
};

export default withCookies(CookiePolicyBannerContainer);
